import { LabelGenerator } from '../../types';

export const isShariaAccount: LabelGenerator = (product) =>
  product.deposit_taking_bank.shariah_compliant && 'ShariaAccount';
